import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetchSyarahv2 from "@/common/fetchSyarahv2";

/**
 *
 * @param source
 * @param phone_number
 * @param otp_length
 * @throws validationException
 */
export var api__sendOtp = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var source, phone_number, otp_length, params;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          source = _ref.source, phone_number = _ref.phone_number, otp_length = _ref.otp_length;
          params = {
            phone_number: phone_number,
            otp_length: otp_length
          };
          _context.n = 1;
          return fetchSyarahv2({
            throwValidationException: true
          }).post("/auth/otp-send?source=".concat(source), params);
        case 1:
          return _context.a(2, _context.v);
      }
    }, _callee);
  }));
  return function api__sendOtp(_x) {
    return _ref2.apply(this, arguments);
  };
}();